import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import "./index.css";
import App from "./App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60_000, // 5 min — events / bottles / celebs barely change
      gcTime: 30 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "rgba(10,10,10,0.95)",
            border: "1px solid rgba(183,110,121,0.4)",
            color: "#fff",
            borderRadius: "2px",
            fontFamily: "Inter, sans-serif",
            fontSize: "0.85rem",
          },
        }}
      />
    </QueryClientProvider>
  </React.StrictMode>,
);
